import { IState } from '../types';
import { MarketplaceProductState, MTrackConsentState, CategorisedProductListItem, MarketplaceProductMetaDataState, CategorisedMarketplaceProductList, MarketplaceProductSummaryState, ProductClientSource } from '../../types/types';

export const getMarketplaceProductsSelector = (state: IState): MarketplaceProductState => state.marketplace.product;

export const getMarketplaceProductListSelector = (state: IState): CategorisedMarketplaceProductList => {
  const productList = state.marketplace.productList;
  const { data, ready, error } = productList;
  const filteredData: CategorisedProductListItem[] = [];
  if (ready && !error) {
    data.products.forEach(product => {
      const { category } = product;
      if (category && typeof category === 'string') {
        const formattedCategory = category.toUpperCase();
        if (!filteredData[formattedCategory]) {
          filteredData[formattedCategory] = [];
        }
        filteredData[formattedCategory].push(product);
      }
    });
  }
  return {
    ...productList,
    ready,
    error,
    data: filteredData,
  };
};

export const getMarketplaceProductMetadata =
  (productId: string) =>
  (state: IState): MarketplaceProductMetaDataState => {
    let productMetadata = {};
    const productList = state.marketplace.productList;
    const { ready, error } = productList;

    if (ready && !error) {
      const productData = productList.data.products.find(product => product.product.productId === productId);
      productMetadata = productData?.product.metadata;
    }

    return {
      ready,
      error,
      data: productMetadata,
    };
  };

export const getMarketplaceProductSummary =
  (productId: string) =>
  (state: IState): MarketplaceProductSummaryState => {
    let productSummary = {};
    let productTitle;

    const productList = state.marketplace.productList;
    const { ready, error } = productList;

    if (ready && !error) {
      const productData = productList.data.products.find(product => product.product.productId === productId);
      if (productData) {
        if (productData.client.source === ProductClientSource.ThirdParty) {
          productTitle = productData.client.id.replace(/_/g, '-').toLowerCase();
        } else {
          productTitle = productData.product?.metadata?.title.replace(/\s/g, '-').toLowerCase();
        }
        productSummary = {
          ...productData.product.metadata,
          productTitle,
        };
      }
    }

    return {
      ready,
      error,
      data: productSummary || {},
    };
  };

export const getMTrackConsentDataSelector = (state: IState): MTrackConsentState => state.marketplace.mTrackConsent;
